export default __webpack_public_path__ + "static/media/UBFC-uB.e5ea94e9.png";